import environment from "flow/configuration/environment";
import config from "flow/config";

function generateProductConfigParams(includeQuestionMark?: boolean) {
    const productId = environment.get(environment.keys.productId);

    const configObj: any = {};

    if (productId) {
        if (productId === config.singleWebModuleProductId) {
            configObj[config.urlParams.singleModule] = environment.get(environment.keys.singleModule);
        } else {
            configObj.productId = productId;

            const payload = environment.get(environment.keys.productPayload); // As JSON string
            if (payload) {
                configObj.payload = payload;
            }
        }

        const prefix = includeQuestionMark ? "?" : "";

        const searchParams = new URLSearchParams(configObj).toString();

        if (searchParams) {
            return prefix + searchParams;
        }
    }

    return "";
}

function getProductConfigParams() {
    const searchParams = new URLSearchParams(window.location.search);
    const productId = searchParams.get("productId");
    const payloadJSON = searchParams.get("payload");

    return {
        productId: productId,
        payload: payloadJSON ? JSON.parse(payloadJSON) : undefined // Up to caller to catch parse exception if any
    };
}

function getForceSingleModule() {
    const searchParams = new URLSearchParams(window.location.search);
    const singleWebModule = searchParams.get("singleModule") ?? searchParams.get("forceSingleModule");

    return singleWebModule;
}

export default {
    generateProductConfigParams: generateProductConfigParams,
    getProductConfigParams: getProductConfigParams,
    getSingleModule: getForceSingleModule
};
